import EducatorSubscription from './EducatorSubscription';
import EducatorWeekPass from './EducatorWeekPass';
import ExplorerDayPass from './ExplorerDayPass';
import ExplorerSubscription from './ExplorerSubscription';
import { ProductType } from './ProductsPromptModal/redux/types';
import SingleHabitatDayPass from './SingleHabitatDayPass';
import SponsorshipSubscription from './SponsorshipSubscription';

/**
 * Render the card for a product type. Shared by the products prompt modal and the Speedy Flow's
 * choose-product step, so the two offer the same thing in the same way.
 *
 * Habitat-scoped products render nothing without a habitat — an offer that cannot name what it
 * unlocks is worse than no offer.
 */
const renderProductCard = (
  productType: ProductType,
  habitatId: string | null | undefined,
  entryPoint: string | undefined,
  variant: 'primary' | 'secondary',
  forEducator?: boolean,
) => {
  switch (productType) {
    case 'single-habitat-day-pass':
      return habitatId ? <SingleHabitatDayPass habitatId={habitatId} entryPoint={entryPoint} /> : null;
    case 'all-habitats-day-pass':
      return <ExplorerDayPass entryPoint={entryPoint} variant={variant} forEducator={forEducator} />;
    case 'educator-week-pass':
      return <EducatorWeekPass entryPoint={entryPoint} />;
    case 'sponsorship':
      return habitatId ? <SponsorshipSubscription habitatId={habitatId} entryPoint={entryPoint} /> : null;
    case 'explorer-pass':
      return <ExplorerSubscription entryPoint={entryPoint} />;
    case 'educator-pass':
      return <EducatorSubscription entryPoint={entryPoint} />;
    default:
      return null;
  }
};

export default renderProductCard;
